import { api, request, setAccessToken } from './http'
import type {
  AdminMe,
  ChangePasswordInput,
  LoginInput,
  LoginResponse,
} from '@influence/contracts-admin'

export const authApi = {
  async login(input: LoginInput): Promise<LoginResponse> {
    const res = await api<LoginResponse>('/admin/auth/login', {
      method: 'POST',
      body: input,
    })
    setAccessToken(res.accessToken)
    return res
  },

  async refresh(): Promise<LoginResponse | null> {
    try {
      const res = await api<LoginResponse>('/admin/auth/refresh', { method: 'POST' })
      setAccessToken(res.accessToken)
      return res
    } catch {
      setAccessToken(null)
      return null
    }
  },

  async logout(): Promise<void> {
    try {
      await api('/admin/auth/logout', { method: 'POST' })
    } finally {
      setAccessToken(null)
    }
  },

  async me(): Promise<AdminMe> {
    return request<AdminMe>('/admin/auth/me')
  },

  async changePassword(input: ChangePasswordInput): Promise<void> {
    await request('/admin/auth/password', { method: 'POST', body: input })
  },
}
